import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import ChangeRequestsReport from './ChangeRequestsReport';

/**
 * The Budget Changes tab on a department's or cost centre's own screen. It calls the
 * same endpoint as the Report Centre report with the location's scope applied, so
 * there is no second data path to keep in step.
 */
if (document.getElementById('LocationBudgetChangeRequests')) {
    const rootEl = document.getElementById('LocationBudgetChangeRequests');

    ReactDOM.render(
        <App>
            <ChangeRequestsReport
                endpoint={rootEl.dataset.endpoint}
                exportUrl={rootEl.dataset.exportUrl}
                locationType={rootEl.dataset.locationType}
                budgetChangesUrl={rootEl.dataset.budgetChangesUrl || null}
                scoped
            />
        </App>,
        rootEl,
    );
}
